import {observer} from 'mobx-react';
import React from 'react';
import {action, makeObservable, observable} from 'mobx';
import store from '../../s';
import {checkout} from '../../../api';
import Message from '../msg';
import * as util from '../../../util';
import ModalLineEP from '../modals/line-ep';
import ModalLineCustom from '../modals/line-custom';
import ModalLineGradYear from '../modals/line-grad-year';
import ModalSimple from '../../../global/modal-simple';

declare var dataLayer: any[];
declare var modalOpen: any;
declare const collapse: {
    init: () => void;
};

interface Props {
    id: number;
    isMobile: boolean;
}

@observer
class CartItems extends React.Component<Props> {
    @observable lastEditedId: number;
    @observable modalImageURL: string;
    @observable modalTitle: string;

    constructor(props) {
        super(props);
        this.doModal = this.doModal.bind(this);
        this.changeQty = this.changeQty.bind(this);
        this.removeProduct = this.removeProduct.bind(this);
        makeObservable(this);
    }

    componentDidMount(): void {
        collapse.init();
    }

    @action
    changeQty = async (e: React.ChangeEvent<HTMLSelectElement> | React.ChangeEvent<HTMLInputElement>, id: number) => {
        store.uiCheckout.isSpecialProcessing = true;
        let newQty = parseInt(e.target.value, 10);
        const item = store.checkout.cart.items.filter(o => o.id === id)[0];
        const oldQty = item.qty;
        this.lastEditedId = id;
        if (newQty === -1) {
            item._showQtyInput = true;
            newQty = 10;
        }
        item.qty = newQty;
        const success = await checkout('update-qty');
        if (!success) {
            item.qty = oldQty;
        }
        store.uiCheckout.isSpecialProcessing = false;
    };

    @action
    removeProduct = async (id: number) => {
        store.uiCheckout.isSpecialProcessing = true;
        let newQty = 0;
        const item = store.checkout.cart.items.filter(o => o.id === id)[0];
        const oldQty = item.qty;
        this.lastEditedId = id;
        if (newQty === -1) {
            item._showQtyInput = true;
            newQty = 10;
        }
        item.qty = newQty;
        const success = await checkout('update-qty');
        if (!success) {
            item.qty = oldQty;
        }
        store.uiCheckout.isSpecialProcessing = false;

        const dle: ga4_dle_remove_from_cart = {
            event: 'remove_from_cart',
            ecommerce: {
                currency: 'USD',
                value: store.checkout.cart.pricing.total,
                items: [
                    {
                        item_id: item.itemId.toString(),
                        item_name: item.title2,
                        item_brand: 'CHC',
                        item_category: item.gaCategory,
                        item_variant: item.gaVariant,
                        coupon: item.gaDiscountCode,
                        index: item.gaPosition,
                        item_list_name: item.gaList,
                        quantity: item.qty,
                        currency: 'USD',
                        price: item.price,
                        location_id: 'ChIJUcHLaPbi54kRtbVMrbSH4MU',
                    },
                ],
            },
        };
        dataLayer.push(dle);

        // ga ua
        dataLayer.push({
            event: 'removeFromCart',
            ecommerce: {
                currencyCode: 'USD',
                add: {
                    // 'add' actionFieldObject measures.
                    products: [
                        {
                            //  adding a product to a shopping cart.
                            name: item.title2,
                            id: item.productId,
                            price: item.price,
                            brand: 'CHC',
                            category: item.gaCategory,
                            variant: item.gaVariant,
                            quantity: item.qty,
                        },
                    ],
                },
            },
        });
    };

    @action
    doModal(o: ICartLineItem) {
        this.modalImageURL = o.imgFull;
        this.modalTitle = `${o.title1} ${o.title2}`;
        modalOpen(`modal-cart-image-${this.props.id.toString()}`);
    }

    render() {
        collapse.init();

        return (
            <div>
                <div className="hr"></div>

                <div className="cs-flex-bottom">
                    <div className="b">In Your Cart</div>
                </div>

                {store.checkout.cart.items.map((o, _p) => (
                    <div key={o.id}>
                        <div className="cs-flex-bottom-items">
                            <div>
                                <img
                                    src={o.imgThumb.replace('_200_200.png', '_400_400.png').replace('com//', 'com/')}
                                    width={200}
                                    height={200}
                                    alt={`${o.title1} ${o.title2}`}
                                    className="resp pointer"
                                    loading="lazy"
                                    tabIndex={0}
                                    onClick={() => this.doModal(o)}
                                    onKeyDown={e => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            this.doModal(o);
                                        }
                                    }}
                                    role="button"
                                    aria-label="Show product photo"
                                />
                                {!store.checkout.isMyFrames && o.is_fast_shipping && o.productId !== 24715 && o.productId !== 24716 && o.productId !== 24717 && o.productId !== 67336 && o.productId !== 67337 && (
                                    <div className={`fast-shipping-mobile fast-shipping-${store.PortalID}`}>
                                        FAST SHIPPING{' '}
                                        <i
                                            className={store.PortalID !== 3 ? `fas fa-shipping-fast` : `fas fa-cart-shopping-fast`}
                                            aria-hidden={true}
                                        ></i>
                                    </div>
                                )}
                                <div style={{paddingTop: 6}}>
                                    {o.productId !== 24791 && (
                                        <div>
                                            <div className="form-inline">
                                                {!o._showQtyInput && (
                                                    <select
                                                        className="form-select change-qty"
                                                        aria-label="Change quantity"
                                                        value={o.qty}
                                                        name={`qty-${_p.toString()}`}
                                                        onChange={e => this.changeQty(e, o.id)}
                                                        style={{width: 80}}
                                                    >
                                                        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20].map((q, _i) => (
                                                            <option
                                                                key={_i}
                                                                value={q}
                                                            >
                                                                {q === -1 ? 'custom' : q.toString()}
                                                            </option>
                                                        ))}
                                                    </select>
                                                )}
                                                <button
                                                    className="link text-btn"
                                                    style={{fontSize: 12, paddingLeft: 24}}
                                                    onClick={() => this.removeProduct(o.id)}
                                                    type="button"
                                                    aria-label="Remove product"
                                                >
                                                    Remove
                                                </button>
                                                {this.lastEditedId === o.id && (
                                                    <div>
                                                        <Message msgType={ICheckoutMessageType.cart_qty} />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div>
                                <div className="title1">
                                    <a
                                        href={o.URL}
                                        aria-label={`View Cart Product ${o.title1}`}
                                    >
                                        {o.title1}
                                    </a>
                                </div>
                                <div className="priceDetail">
                                    {o.qty > 1 ? `Qty: ${o.qty} @` : ''} {util.currency(o.price)}
                                </div>
                                {o.VolumeDiscountAmt > 0 && (
                                    <div className="volume">
                                        Saving <b>{util.currency(o.VolumeDiscountAmt)}</b> with {o.VolumeDiscountPercent}% volume discount
                                    </div>
                                )}
                                {o.discountHighlight !== '' && (
                                    <div
                                        className="discount-highlight"
                                        dangerouslySetInnerHTML={{__html: o.discountHighlight}}
                                    />
                                )}
                                {!util.isNullOrWhiteSpace(o.special_msg) && <div className="discount-highlight">{o.special_msg}</div>}
                                <div className="toggle-content-2">
                                    {o.productId !== 24791 && (
                                        <button
                                            className="more text-btn"
                                            type="button"
                                            aria-label="Show details"
                                            aria-controls={`details-${this.props.id.toString()}-cs-${o.id.toString()}`}
                                            onClick={() => (o._showingDetail = !o._showingDetail)}
                                            style={{fontSize: 16}}
                                        >
                                            Details
                                            <span style={{paddingLeft: 6}}>
                                                {!o._showingDetail && (
                                                    <i
                                                        className={'fa fa-plus'}
                                                        aria-hidden={true}
                                                    />
                                                )}
                                                {o._showingDetail && (
                                                    <i
                                                        className={'fa fa-minus'}
                                                        aria-hidden={true}
                                                    />
                                                )}
                                            </span>
                                        </button>
                                    )}
                                    <div
                                        id={`details-${this.props.id.toString()}-cs-${o.id.toString()}`}
                                        style={{padding: 0, display: o._showingDetail ? 'block' : 'none'}}
                                        aria-hidden={!o._showingDetail}
                                    >
                                        <div className="details">
                                            <div className="title2">
                                                <a
                                                    href={o.URL}
                                                    aria-label={`View Cart Product ${o.title2}`}
                                                >
                                                    {o.title2}
                                                </a>
                                            </div>
                                            {o.details.map((d, i) => (
                                                <div
                                                    key={i}
                                                    dangerouslySetInnerHTML={{__html: d}}
                                                />
                                            ))}
                                            {o.hasEp && (
                                                <div>
                                                    <div>
                                                        <span className="details-title">{o.epTitle}</span>
                                                        {this.props.isMobile && (
                                                            <span
                                                                style={{
                                                                    paddingLeft: 4,
                                                                    fontSize: 12,
                                                                }}
                                                                className="link"
                                                                onClick={() => modalOpen(`modal-l-ep-cs-${o.id}`)}
                                                            >
                                                                <i className="fas fa-edit link pointer"></i>
                                                            </span>
                                                        )}
                                                        {!this.props.isMobile && store.checkout.cstep !== ICheckoutStep.cart && (
                                                            <span
                                                                style={{
                                                                    paddingLeft: 4,
                                                                    fontSize: 12,
                                                                }}
                                                                className="link"
                                                                onClick={() => store.moveStep(0)}
                                                            >
                                                                <i className="fas fa-edit link pointer"></i>
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div style={{paddingLeft: 6}}>
                                                        {o.ep1 && <div>{o.ep1}</div>}
                                                        {o.ep2 && <div>{o.ep2}</div>}
                                                        {o.ep3 && <div>{o.ep3}</div>}
                                                        {o.ep4 && <div>{o.ep4}</div>}
                                                        {o.ep5 && <div>{o.ep5}</div>}
                                                        {o.ep6 && <div>{o.ep6}</div>}
                                                        {o.ep7 && <div>{o.ep7}</div>}
                                                        {o.ep8 && <div>{o.ep8}</div>}
                                                        {o.ep9 && <div>{o.ep9}</div>}
                                                        {o.ep10 && <div>{o.ep10}</div>}
                                                    </div>
                                                    <ModalLineEP
                                                        id={o.id}
                                                        modalId={`modal-l-ep-cs-${o.id}`}
                                                    />
                                                </div>
                                            )}
                                        </div>

                                        {o.hasCustom && (
                                            <div>
                                                <div>
                                                    {o.CustomField1_Title.length > 0 && o.CustomField1_Title.trim().length > 0 && (
                                                        <div>
                                                            <span
                                                                className="details-title"
                                                                style={{color: '#616161'}}
                                                            >
                                                                {o.CustomField1_Title}:
                                                            </span>{' '}
                                                            {o.CustomField1}
                                                            <span
                                                                style={{
                                                                    paddingLeft: 4,
                                                                    fontSize: 12,
                                                                }}
                                                                className="link"
                                                                onClick={() => modalOpen(`modal-line-custom-${o.id}`)}
                                                            >
                                                                <i className="fas fa-edit link pointer"></i>
                                                            </span>
                                                        </div>
                                                    )}
                                                    {o.CustomField2_Title.length > 0 && o.CustomField2_Title.trim().length > 0 && (
                                                        <div>
                                                            <span
                                                                className="details-title"
                                                                style={{color: '#616161'}}
                                                            >
                                                                {o.CustomField2_Title}:
                                                            </span>{' '}
                                                            {o.CustomField2}
                                                            <span
                                                                style={{
                                                                    paddingLeft: 4,
                                                                    fontSize: 12,
                                                                }}
                                                                className="link"
                                                                onClick={() => modalOpen(`modal-line-custom-${o.id}`)}
                                                            >
                                                                <i className="fas fa-edit link pointer"></i>
                                                            </span>
                                                        </div>
                                                    )}
                                                    {o.CustomField3_Title.length > 0 && o.CustomField3_Title.trim().length > 1 && (
                                                        <div>
                                                            <span
                                                                className="details-title"
                                                                style={{color: '#616161'}}
                                                            >
                                                                {o.CustomField3_Title}:
                                                            </span>{' '}
                                                            {o.CustomField3}
                                                            <span
                                                                style={{
                                                                    paddingLeft: 4,
                                                                    fontSize: 12,
                                                                }}
                                                                className="link"
                                                                onClick={() => modalOpen(`modal-line-custom-${o.id}`)}
                                                            >
                                                                <i className="fas fa-edit link pointer"></i>
                                                            </span>
                                                        </div>
                                                    )}
                                                    <ModalLineCustom
                                                        id={o.id}
                                                        modalId={`modal-line-custom-${o.id}`}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        {!o.IsDYF && o.gradYear > 0 && (
                                            <div>
                                                <div>
                                                    Grad Year: {o.gradYear.toString()}
                                                    <span
                                                        style={{paddingLeft: 4, fontSize: 12}}
                                                        className="link"
                                                        onClick={() => modalOpen(`modal-line-grad-year-${o.id}`)}
                                                    >
                                                        <i className="fas fa-edit link pointer"></i>
                                                    </span>
                                                </div>
                                                <ModalLineGradYear
                                                    id={o.id}
                                                    modalId={`modal-line-grad-year-${o.id}`}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {o.messages
                            .filter(y => y.msgType === ICheckoutMessageType.backorder)
                            .map(x => (
                                <div
                                    className="alert alert-info"
                                    style={{margin: '2% 5%'}}
                                >
                                    {x.msg}
                                </div>
                            ))}
                        <div className="hr"></div>
                    </div>
                ))}

                <ModalSimple
                    id={`modal-cart-image-${this.props.id.toString()}`}
                    title={`${this.modalTitle}`}
                >
                    <div>
                        <img
                            src={this.modalImageURL}
                            alt={`${this.modalTitle}`}
                            className="resp"
                        />
                    </div>
                </ModalSimple>
            </div>
        );
    }
}

export default CartItems;
